/**
 * Standard error response class
 * Represents the unified error format that will be used in the future
 */
export class BackendRpErrorResponse {
  app_name = null;
  status_code = 500;
  message = 'An error occurred';
  message_code = 'UNKNOWN_ERROR';
  validations = [];

  constructor(data = {}) {
    if (data.app_name !== undefined) this.app_name = data.app_name;
    if (data.status_code !== undefined) this.status_code = data.status_code;
    if (data.message !== undefined) this.message = data.message;
    if (data.message_code !== undefined) this.message_code = data.message_code;
    if (data.validations !== undefined) this.validations = data.validations;
  }

  allErrorMessages() {
    let msg = `${this.message}`;
    if (this.validations.length > 0) {
      msg = "Errores de Validacion:\n";
      msg += this.validations.map(v => `${v.property_name}: ${v.error_message}`).join('\n');
    }
    return msg;
  }

  firstErrorMessage() {
    let msg =  `${this.message_code}: ${this.message}`;
    if (this.validations.length > 0) {
      msg = "Errores de Validacion:\n";
      msg += `${this.validations[0].property_name}: ${this.validations[0].error_message}`;
    }
    return msg;
  }

  static allErrorMessages(error) {
    if (error instanceof BackendRpErrorResponse) {
      return error.allErrorMessages();
    }
    return error?.message || 'An error occurred';
  }

  static firstErrorMessage(error) {
    if (error instanceof BackendRpErrorResponse) {
      return error.firstErrorMessage();
    }
    return error?.message || 'An error occurred';
  }
}
